import { render, staticRenderFns } from "./OnDelete.vue?vue&type=template&id=056104c0&"
import script from "./OnDelete.vue?vue&type=script&lang=js&"
export * from "./OnDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports